import React, { FC } from 'react';
import { Box } from '@dxb-web-ui-framework/design-system';

const ListCardAction: FC = ({ children }) => (
  <Box paddingY={3} display='flex' justifyContent='center'>
    {children}
  </Box>
);

export { ListCardAction };
